import React, {useEffect, useState} from 'react'
import {Form, Formik} from "formik";
import {InputField} from "../../../../components/Custom/Form/InputField";
import FormGroup from "../../../../components/Custom/Form/FormGroup";
import {FormSelect} from "../../../../components/Custom/Form/FormSelect";
import programService from "../../../../services/programService";
import GenericCanvasActions from "../../../../components/Custom/UI/Canvas/GenericCanvasActions";
import GenericOffCanvas from "../../../../components/Custom/UI/Canvas/GenericOffCanvas";
import {programForm} from "./programForm";
import {WorkTypeArray} from "../../../../constants/enums/WorkTypesEnum";
import DeleteButton from "../../../../components/Custom/Form/Buttons/DeleteButton";
import {toast} from "react-toastify";

const ProgramOffCanvas = ({isOpen, toggle, type, data, handleResponse}) => {

    const [initialValues, setInitialValues] = useState(programForm.initialValues)
    const handleSubmit = (values) => data ? programService.update(data.uuid, values) : programService.store(values);

    useEffect(() => {
        data ? setInitialValues({
            name: data.name || '',
            description: data.description || '',
            note: data.note || '',
            work_types: data.work_types ? data.work_types.map(wt => wt.value) : [],
        }) : setInitialValues(programForm.initialValues)
    }, [data]);

    const handleDelete = () => programService.destroy(data.uuid)
        .then(res => {
            toast.success('Operazione eseguita con successo')
            handleResponse(undefined)
            toggle(false)
        })
        .catch(err => toast.error(err.response.data.message))


    return (<GenericOffCanvas
            title={data ? 'Modifica ' + data.name : 'Crea programma'}
            isOpen={isOpen}
            toggle={toggle}>
            <Formik
                initialValues={initialValues}
                validationSchema={programForm.validation}
                enableReinitialize={true}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                        .then(res => {
                            toast.success('Operazione eseguita con successo')
                            handleResponse(res)
                            toggle(false)
                        })
                        .catch(err => toast.error(err.response.data.message))
                        .finally(() => setSubmitting(false))
                }}>
                {({setFieldValue}) => (
                    <Form>
                        <FormGroup name="name" label="Nome" required={true} inline={false}>
                            <InputField name="name" type="text" maxLength={100}/>
                        </FormGroup>
                        <FormGroup name="description" label="Descrizione" required={false}
                                   inline={false}>
                            <InputField name="description" type="text"/>
                        </FormGroup>
                        <FormGroup name="work_types" label="Tipo di lavorazione" inline={false}>
                            <FormSelect multiple={true}
                                        name="work_types"
                                        onChange={(value) => setFieldValue('work_types', value)}
                                        placeholder="Seleziona un tipo di lavorazione"
                                        options={WorkTypeArray}/>
                        </FormGroup>
                        <FormGroup name="note" label="Note" required={false} inline={false}>
                            <InputField name="note" component="textarea" rows={6}/>
                        </FormGroup>
                        <GenericCanvasActions toggle={toggle}>
                            {data?.uuid &&
                                <DeleteButton
                                    handleClick={() => handleDelete()}
                                    message={data?.items_works_count ? 'Ci sono articoli collegati, Vuoi elimnarlo comunnque?' : null}
                                />
                            }
                        </GenericCanvasActions>
                    </Form>
                )}
            </Formik>
        </GenericOffCanvas>
    )

}
export default ProgramOffCanvas
